// src/Pages/Load/LoadContainer/components/BentoBox.jsx

"use client";

import React from "react";

export default function BentoBox({ title, icon: Icon, children, className = "" }) {
  return (
    <div className={`p-4 bg-[#292826] rounded-lg shadow ${className}`}>
      <h3 className="text-lg font-semibold mb-2 flex items-center text-white">
        <Icon className="mr-2 h-5 w-5" />
        {title}
      </h3>
      {children}
    </div>
  );
}